import { render, staticRenderFns } from "./Identify.vue?vue&type=template&id=37d6a1b7&scoped=true&"
import script from "./Identify.vue?vue&type=script&lang=ts&"
export * from "./Identify.vue?vue&type=script&lang=ts&"
import style0 from "./Identify.vue?vue&type=style&index=0&id=37d6a1b7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d6a1b7",
  null
  
)

export default component.exports